<!-- 充值配置 -->
<template>
  <div>
    <div>
      <div class="p_row" style="display: flex;justify-content:space-around;">
        <span class="sp">总量：{{addParams.oriRechargeCount}}</span>
        <span class="sp">扣量：{{addParams.dedRechargeCount}}</span>
        <span class="sp">计划扣量：{{addParams.preDedRechargeCount}}</span>
      </div>
      <div style="margin-left:4px;color:#000"></div>
      <el-divider></el-divider>
    </div>
    <!-- 扣新增充值折线图 -->
    <div
      class="line"
      ref="regChart"
      style="width:560px;height:320px;margin-left:-30px;margin-bottom:15px"
    ></div>
    <!-- 扣新增充值折线图下方表单 -->
    <el-form
      :model="rechargeParam"
      label-width="120px"
      ref="rechargeForm"
      :label-position="labelPosition"
    >
      <el-form-item label="采用时间:">
        <el-date-picker
          style="width:250px"
          size="small"
          v-model="time"
          type="daterange"
          range-separator="——"
          start-placeholder="开始日期"
          end-placeholder="结束日期:"
          @change="changeTime"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="起扣时间:">
        <el-date-picker
          v-model="rechargeParam.rechgDedAt"
          type="datetime"
          placeholder="选择日期时间"
          size="small"
          @click="rechgDedTime()"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="扣量起点(个):">
        <el-input-number
          v-model.number="rechargeParam.rechgDedLowerOutset"
          @change="rechgChartData()"
          placeholder="输入数字"
          :precision="0"
          :step="1"
          :min="0"
          size="small"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="扣量比:">
        <el-input-number
          v-model="rechargeParam.rechgDeductionRatio"
          placeholder="输入数字"
          @change="rechgChartData()"
          :precision="2"
          :step="0.01"
          :max="1"
          :min="0"
          size="small"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="开关:">
        <el-switch
          v-model="active"
          active-color="#13ce66"
          inactive-color="#666666"
          active-text="开启"
          inactive-text="关闭"
        ></el-switch>
      </el-form-item>
      <el-form-item class="myFooter" style="position: absolute;bottom: -35px;right: 20px;">
        <!-- <el-button size="small">取 消</el-button> -->
        <el-button
          type="primary"
          @click="submitForm('rechargeForm')"
          :loading="flag"
          size="small"
        >保 存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import API from "@/api";
import echarts from "echarts";
import { changeTime, changeSumDate } from "@/utils/global";
export default {
  props: ["querry", "rechargeTime"],
  data() {
    return {
      active: "",
      labelPosition: "left",
      // 提交按钮状态
      flag: false,
      time: "",
      addParams: {}, //图表上方需要展示字段
      rechargeParam: {
        id: "", //唯一码
        discCode: "",
        rechgDeductionRatio: 0, //充值扣量比例
        rechgDedLowerOutset: 0, //充值扣量起点
        rechgDedAt: "" //充值扣量时间
        // deductType: ""
      },
      rechargeAnalysis: {}
    };
  },
  created() {
    this.intRecharge();
  },
  methods: {
    submitForm(rechargeForm) {
      this.$refs[rechargeForm].validate(valid => {
        if (valid) {
          this.editRecharge();
        } else {
          return false;
        }
      });
    },
    editRecharge() {
      let param = Object.assign({}, this.rechargeParam, this.rechargeAnalysis, {
        deductType: this.active === true ? 8 : 0
      });
      API.updateDedRecharge(param)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "编辑充值配置成功！",
              type: "success"
            });
            this.$emit("editPage");
          } else {
            this.$message.error("编辑充值配置失败！");
          }
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
        });
    },
    //扣充值--采样时间回掉
    changeTime(time) {
      this.rechargeAnalysis.startTime = time[0]
        ? changeSumDate(time[0])
        : undefined;
      this.rechargeAnalysis.endTime = time[1]
        ? changeSumDate(time[1])
        : undefined;
      this.rechgChartData();
    },
    //扣充值--起扣时间
    rechgDedTime() {
      this.rechgChartData();
    },
    rechgChartData() {
      // 初始化echart实例
      let myChart = echarts.init(this.$refs.regChart);
      const subTit = "充值趋势图";
      myChart.showLoading({
        text: "拼命加载中",
        color: "#d54867",
        textColor: "#d54867",
        maskColor: "rgba(255,255,255,0.8)",
        zlevel: 0
      });
      // 折线图数据接口
      // 获取新增扣充值数据
      const param = {
        startTime: changeSumDate(this.time[0]),
        endTime: changeSumDate(this.time[1]),
        discCode: this.rechargeParam.discCode,
        dedLowerOutset: this.rechargeParam.rechgDedLowerOutset,
        rechargeDedAt: changeTime(this.rechargeParam.rechgDedAt),
        rechargeDedRatio: this.rechargeParam.rechgDeductionRatio
      };
      let getLineChartData = API.handleRechargeAnalysis(param);
      getLineChartData
        .then(res => {
          if (res.code == 200) {
            let time = [];
            // 新增充值要展示字段
            this.addParams = {
              oriRechargeCount: res.data.oriRechargeCount,
              dedRechargeCount: res.data.dedRechargeCount,
              preDedRechargeCount: res.data.preDedRechargeCount
            };
            let oriRechargeCountMap = [];
            let oriDedRechargeCountMap = [];
            let preDedRechargeCountMap = [];
            let tit = [];
            tit.push("原始");
            tit.push("扣量");
            tit.push("计划");

            Object.keys(res.data.oriRechargeCountMap).forEach(key => {
              time.push(key + "h");
              if (res.data.oriRechargeCountMap[key] !== undefined) {
                oriRechargeCountMap.push(res.data.oriRechargeCountMap[key]);
              }
              if (res.data.oriDedRechargeCountMap[key] !== undefined) {
                oriDedRechargeCountMap.push(
                  res.data.oriDedRechargeCountMap[key]
                );
              }
              if (res.data.preDedRechargeCountMap[key] !== undefined) {
                preDedRechargeCountMap.push(
                  res.data.preDedRechargeCountMap[key]
                );
              }
            });
            myChart.hideLoading();
            let option = {
              title: {
                text: `${subTit}`
              },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  label: {
                    backgroundColor: "#6a7985"
                  }
                }
              },

              color: ["#1e9f38", "#111110", "#c51f00"],
              legend: {
                data: [tit[0], tit[1], tit[2]]
              },
              xAxis: {
                min: -1,
                type: "category",
                boundaryGap: false,
                data: time,
                axisLine: { onZero: false }
              },
              yAxis: {
                min: -1,
                type: "value",
                axisLabel: {
                  formatter: "{value} "
                },
                axisLine: { onZero: false }
              },
              series: [
                {
                  name: tit[0],
                  type: "line",
                  smooth: true,
                  data: oriRechargeCountMap,
                  markPoint: {
                    data: [
                      { type: "max", name: "最大值" },
                      { type: "min", name: "最小值" }
                    ]
                  },
                  markLine: {
                    data: [{ type: "average", name: "平均值" }]
                  }
                },
                {
                  name: tit[1],
                  type: "line",
                  smooth: true,
                  data: oriDedRechargeCountMap,
                  markPoint: {
                    data: [
                      { type: "max", name: "最大值" },
                      { type: "min", name: "最小值" }
                    ]
                  },
                  markLine: {
                    data: [{ type: "average", name: "平均值" }]
                  }
                },
                {
                  name: tit[2],
                  type: "line",
                  smooth: true,
                  data: preDedRechargeCountMap,
                  markPoint: {
                    data: [
                      { type: "max", name: "最大值" },
                      { type: "min", name: "最小值" }
                    ]
                  },
                  markLine: {
                    data: [{ type: "average", name: "平均值" }]
                  }
                }
              ]
            };
            myChart.setOption(option);
          } else {
            myChart.showLoading({
              text: "暂无数据",
              color: "rgba(250,250,250,0.1)",
              textColor: "#8a8e91",
              maskColor: "rgba(255, 255, 255, 0.8)"
            });
            this.load = false;
          }
        })
        .catch(() => {
          myChart.showLoading({
            text: "暂无数据",
            color: "rgba(250,250,250,0.1)",
            textColor: "#8a8e91",
            maskColor: "rgba(255, 255, 255, 0.8)"
          });
          this.load = false;
        });
    },

    updateRechargeParam(val) {
      this.rechargeParam = {
        rechgDeductionRatio: val.rechgDeductionRatio,
        rechgDedLowerOutset: val.rechgDedLowerOutset,
        rechgDedAt: val.rechgDedAt,
        id: val.id,
        discCode: val.districtCode
      };
      this.time = this.rechargeTime;
      this.rechargeAnalysis = val.rechargeAnalysis;

      this.active = Boolean(val.deductType & 8);
    },
    intRecharge() {
      this.updateRechargeParam(this.querry);
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    querry: function(val, oldVal) {
      this.updateRechargeParam(val);
    }
  }
};
</script>

<style lang='' scoped>
</style>